import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { HttpTokenService } from '../../../services/http.token.service';
import { Subscription } from 'rxjs';

/**
 * Floating AI Chat Button Component
 * Shows a fixed-position button in the bottom-right corner
 * Only visible for practice users
 */
@Component({
    selector: 'app-ai-chat-button',
    templateUrl: './ai-chat-button.component.html',
    styleUrls: ['./ai-chat-button.component.scss']
})
export class AiChatButtonComponent implements OnInit, OnDestroy {
    public showButton = false;
    public isChatOpen = false;
    private subscriptions: Subscription[] = [];

    constructor(
        public userService: UserService,
        private tokenService: HttpTokenService
    ) { }

    ngOnInit(): void {
        // Check immediately if user is already loaded
        this.checkUserType();

        // Subscribe to authentication events to check when user logs in
        const authSub = this.tokenService.subscriptionObserver.subscribe(() => {
            // Small delay to ensure user data is fully loaded
            setTimeout(() => {
                this.checkUserType();
            }, 100);
        });
        this.subscriptions.push(authSub);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    /**
     * Check if current user is a practice user
     */
    private checkUserType(): void {
        console.log('Checking user type. Current user:', this.userService.current_user);
        if (this.userService.current_user && this.userService.current_user.userType === 'practice') {
            console.log('Practice user detected! Showing chat button.');
            this.showButton = true;
        } else {
            console.log('Not a practice user or user not loaded yet.');
            this.showButton = false;
        }
    }

    /**
     * Toggle chat window open/close
     */
    public toggleChat(): void {
        this.isChatOpen = !this.isChatOpen;
        // Emit event to parent component
        const event = new CustomEvent('toggleChat', { detail: this.isChatOpen });
        window.dispatchEvent(event);
    }
}
